import { useContext } from 'react';
import { RootContext } from '../../../stores';
import { usePromiseResolver } from '../../../shared/general/hooks';

export default function useVolunteerOrganizations() {
    const { volunteerStore } = useContext(RootContext);
    const { result: volunteerOrganizations, loading } = usePromiseResolver({ promise: volunteerStore.getVolunteerOrganizations });
    return { volunteerOrganizations, loading };
}